import React, { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import CloseIcon from '../../../themes/svg/closeIcon';
import * as steps from './steps/stepTypes';
import * as designBuilderApi from '../../../api/designBuilder';
import config from '../../../helpers/config';
import { sites } from '../../../helpers/globalVariables';

import EnterAddress from './steps/EnterAddressConnector';
import ConfirmAddress from './steps/ConfirmAddressConnector';
import CoveredByThd from './steps/CoveredByThdConnector';
import CoveredByOther from './steps/CoveredByOtherConnector';

class AvailabilityModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: steps.ENTER_ADDRESS,
    };
  }

  componentWillMount() {
    Modal.setAppElement('#estimateBuilderRoot');
  }

  componentDidUpdate() {
  }

  onAfterModalOpened = () => {
    if (this.props.display) {
      this.checkProductEligibility(this.props.selectedEstimate);
      if (config.siteId === sites.theHomeDepot) {
        this.props.getProductIdMap(this.props.selectedEstimate, this.closeModal);
      }
    }
  };

  onStep = givenStep => this.state.step === givenStep;

  checkProductEligibility = (designId) => {
    designBuilderApi
      .confirmEligibility(designId)
      .then((response) => {
        this.props.updateEligibility(response.data);
      })
      .catch((err) => {
        this.closeModal();
        this.props.globalError({ err });
      });
  };

  advanceToConfirm = () => {
    this.changeStep(steps.CONFIRM_ADDRESS);
  };

  returnToEnterAddress = (e) => {
    e.preventDefault();
    this.changeStep(steps.ENTER_ADDRESS);
  };

  advanceByCoverage = (covered) => {
    this.changeStep(covered ? steps.COVERED_BY_THD : steps.COVERED_BY_OTHER);
  };

  changeStep = (step) => {
    this.setState({
      step,
    });
  };

  closeModal = () => {
    this.setState({ step: steps.ENTER_ADDRESS }, () => {
      this.props.resetAvailabilityModal();
      this.props.closeModal();
    });
  };

  render() {
    return (
      <Modal
        isOpen={this.props.display}
        onAfterOpen={this.onAfterModalOpened}
        className="estimatebuilder-modal"
        overlayClassName="estimatebuilder-modal-overlay"
        onRequestClose={this.closeModal}
        style={{
          content: {
            width: 450,
          },
        }}
        onClick={this.closeModal}
      >
        <div className="availability-modal">
          <h2 className="modal-header desktop-tablet-only">Professional Measure &amp; Install</h2>
          <h2 className="modal-header mobile-only">Pro Measure &amp; Install</h2>
          <div className="modal-close" tabIndex="-1" role="button" onClick={this.closeModal}>
            <CloseIcon />
          </div>
          <div className="modal-body">
            {this.onStep(steps.ENTER_ADDRESS) && <EnterAddress advance={this.advanceToConfirm} />}
            {this.onStep(steps.CONFIRM_ADDRESS) && (
              <ConfirmAddress advance={this.advanceByCoverage} goBack={this.returnToEnterAddress} />
            )}
            {this.onStep(steps.COVERED_BY_THD) && <CoveredByThd />}
            {this.onStep(steps.COVERED_BY_OTHER) && <CoveredByOther />}
          </div>
        </div>
      </Modal>
    );
  }
}

AvailabilityModal.propTypes = {
  display: PropTypes.bool,
  closeModal: PropTypes.func.isRequired,
  updateEligibility: PropTypes.func.isRequired,
  resetAvailabilityModal: PropTypes.func.isRequired,
  globalError: PropTypes.func.isRequired,
  selectedEstimate: PropTypes.string.isRequired,
  getProductIdMap: PropTypes.func.isRequired,
};

AvailabilityModal.defaultProps = {
  display: false,
};

export default AvailabilityModal;
